export default __webpack_public_path__ + "static/media/Rectangle 1.5ab8c315.svg";